<template>
  <div>
    <h5 class="sub-title">{{ editOrCreate }} Parent</h5>
    <div id="alerts" ref="student-parents-alert">
      <b-alert
        :show="dismissCountDown"
        dismissible
        variant="success"
        @dismissed="dismissCountDown = 0"
        @dismiss-count-down="countDownChanged"
        >You have successfully added a parent!</b-alert
      >
      <b-alert :show="showError" dismissible variant="warning">
        Something went wrong. Please refresh and try again, or contact the site
        admin.
      </b-alert>
    </div>
    <b-row id="basic-info">
      <b-col>
        <div class="firstName mt-4">
          <label for="firstName">
            First Name:
            <b-form-input
              name="first_name"
              type="text"
              id="first_name"
              v-model="parent.first_name"
              :state="firstNameInput"
            ></b-form-input>
          </label>
        </div>
        <div class="middleName mt-4">
          <label for="middleName">
            Middle Name:
            <b-form-input
              name="middle_name"
              type="text"
              id="middle_name"
              v-model="parent.middle_name"
            ></b-form-input>
          </label>
        </div>
        <div class="lastName mt-4">
          <label for="lastName">
            Last Name:
            <b-form-input
              name="last_name"
              type="text"
              id="last_name"
              v-model="parent.last_name"
              :state="lastNameInput"
            ></b-form-input>
          </label>
        </div>
        <div class="sex mt-4">
          <label for="sex">
            Sex:
            <br />
            <b-form-select
              name="sex"
              type="text"
              id="sex"
              v-model="parent.sex"
              :state="sexInput"
            >
              <option disabled value>Select a Sex</option>
              <option value="male">Male</option>
              <option value="female">Female</option>
            </b-form-select>
          </label>
        </div>
        <div class="relation mt-4">
          <label class="left" for="relation">
            Relation to student:
            <b-form-input
              name="relation"
              type="text"
              id="relation"
              v-model="parent.relation"
            ></b-form-input>
          </label>
        </div>
      </b-col>
      <b-col>
        <div class="mobile_1 mt-4">
          <label for="mobile_2">
            Mobile Number:
            <b-form-input
              v-validate="mobileValidation"
              @keyup.enter="emitValue(!required)"
              type="tel"
              name="mobile_1"
              v-model="parent.mobile_1"
            ></b-form-input>
          </label>
          <p v-if="errors.has('mobile_1')">{{ errors.first('mobile_1') }}</p>
        </div>
        <div class="mobile_2 mt-4">
          <label for="mobile_2">
            Mobile Number:
            <b-form-input
              v-validate="mobileValidation"
              @keyup.enter="emitValue(!required)"
              type="tel"
              name="mobile_2"
              v-model="parent.mobile_2"
            ></b-form-input>
          </label>
          <p v-if="errors.has('mobile_2')">{{ errors.first('mobile_2') }}</p>
        </div>
        <div class="email mt-4">
          <label for="email">
            Email Address:
            <b-form-input
              type="email"
              v-model="parent.email"
              v-validate="'required|email'"
              :class="{ input: true, 'is-danger': errors.has('email') }"
              name="email"
            ></b-form-input>
          </label>
          <p v-if="errors.has('email')" class="help is-danger">
            {{ errors.first('email') }}
          </p>
        </div>
      </b-col>
    </b-row>
    <b-button variant="primary" @click="addOrUpdate">{{
      buttonTitle
    }}</b-button>
  </div>
</template>

<script>
import ParentService from '../services/ParentService';
import { flash } from '../mixins/flashes';
import { scrollTo } from '../mixins/scrollTo';

export default {
  name: 'EditParent',
  mixins: [flash, scrollTo],

  props: {
    parent: {
      id: Number,
      sp_id: Number,
      first_name: String,
      middle_name: String,
      last_name: String,
      sex: String,
      relation: String,
      mobile_1: String,
      mobile_2: String,
      email: String,
    },
    buttonTitle: String,
    editOrCreate: String,
  },
  data() {
    return {
      mobileValidation: 'numeric|min:9|max:10',
    };
  },
  methods: {
    addOrUpdate() {
      if (this.buttonTitle.includes('Edit')) {
        this.updateParent();
      } else {
        this.createParent();
      }
    },
    async createParent() {
      const data = { ...this.parent };
      const { relation } = this.parent;
      delete data.id;
      delete data.sp_id;
      delete data.relation;
      await ParentService.createStudentParent(data, relation).catch(err => {
        this.flashError(err);
      });
      await this.scrollTo('student-parents-alert');
      await this.flashSuccess();
      this.$emit('click');
    },
    async updateParent() {
      const data = { ...this.parent };
      await ParentService.updateStudentParent(data).catch(err => {
        this.flashError(err);
      });
      await this.scrollTo('student-parents-alert');
      await this.flashSuccess();
      this.$emit('click');
    },
  },
  computed: {
    firstNameInput() {
      return this.parent.first_name.length > 2;
    },
    lastNameInput() {
      this.parent.last_name.length > 2;
    },
    sexInput() {
      this.parent.sex.length > 2;
    },
  },
};
</script>
